/** Sentinel stored on default presets; it is not an Atlante group. */
export const DEFAULT_GROUP_CODE = 'DEFAULT'

export const isDefaultGroupCode = (codiceGruppo) => codiceGruppo === DEFAULT_GROUP_CODE

/**
 * Whether the community panel can proceed past group resolution.
 * Default presets and the DEFAULT sentinel do not require an Atlante group.
 */
export const canSaveCommunityGroupSelection = ({
  defaultPreset,
  codiceGruppo,
  descrizioneGruppo,
  group
} = {}) => {
  if (defaultPreset || isDefaultGroupCode(codiceGruppo)) return true

  const hasCodeOrDescription = Boolean(codiceGruppo || descrizioneGruppo)
  const isGroupValid = hasCodeOrDescription && Boolean(group?.found)
  const hasGroupCodes = Boolean(group?.codice && group?.descrizione)
  const areCodesMissing = !codiceGruppo && !descrizioneGruppo

  return isGroupValid || hasGroupCodes || areCodesMissing
}
